import moment from 'moment';

export function compareValues(key, order = 'ascending') {
  return function (a, b) {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      // property doesn't exist on either object
      return 0;
    }
    let comparison = 0;

    if (isNaN(a[key]) && isNaN(b[key])) {
      var aDate = moment(a[key]);
      var bDate = moment(b[key]);

      if (aDate.isValid() && bDate.isValid()) {

        var difference = aDate.diff(bDate);
        if (difference > 1) {
          comparison = 1;
        } else {
          comparison = -1;
        }
      }
    }


    const varA = (typeof a[key] === 'string') ?
      a[key].toUpperCase() : a[key];
    const varB = (typeof b[key] === 'string') ?
      b[key].toUpperCase() : b[key];

    if (comparison === 0) {
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
    }
    return (
      (order == 'descending') ? (comparison * -1) : comparison
    );
  };
}


// WEBPACK FOOTER //
// ./src/utils/sorting.js